import React, { Component } from 'react';
import styled from 'styled-components';
import { connectDeep } from 'redux-utils';
import App from 'models/app';
import { ContentList, ItemRow } from '../../components/v2/AppContentList/index';
import HomeContainer from 'components/v2/HomeContainer';
import { Transition } from 'components/v2/Transition';
import { ScrollContainer } from 'components/v2/ScrollContainer';
import Typography from '../../components/v2/Typography';
import i18n from 'i18n';
import { ButtonLink } from '../../components/v2/Button/index';
import AppShapedImage from '../../components/v2/AppShapedImage/index';
import { roundEdgeDevices, RoutePaths } from '../../constants';


const StyledAppShapedImage = styled(AppShapedImage)`
  flex-shrink: 0;
`;

const TruncatedTypography = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

const Container = styled.div`
  height: calc(100vh - 64px);
  overflow-y: auto;
  background: var(--sys-color--surface);
  display: flex;
  flex-direction: column;
`;

const BottomFixedBar = styled.div`
  margin-top: auto;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 32px;
  background: var(--sys-color--surface);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  @media (min-width: 321px) {
    padding: 16px 24px;
  }
`;

const StyledLinkContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  text-decoration: none;

  a {
    width: 100%;
  }
`;

const mapStateToProps = (state: any) => {
  const { registry } = state;
  const {
    installed: { loading: installedLoading, error, tileStatuses = [] },
    features: { loading: featuresLoading },
  } = registry;

  const deviceName = registry.currentUser?.device?.productName || null;

  let installedTiles = [];
  if (tileStatuses && tileStatuses.length > 0) {
    installedTiles = tileStatuses
      .map((tile: any) => App.selectFromState(tile.tileId, state))
      .filter((app: any) => app && app.isTileInstalled);
  }

  return {
    loading: (installedLoading && tileStatuses.length === 0) || featuresLoading,
    error,
    installedTiles,
    deviceName,
  };
};

class InstalledTilesPage extends Component<any> {
  renderBody() {
    const { installedTiles, deviceName } = this.props;

    return (
      <ScrollContainer scrollKey="installedTilesPage" navbarHeight={64}>
        <Container>
          <ContentList>
            {installedTiles.map((tile: any) => {
              const photo = (
                <StyledAppShapedImage
                  photoProperties={{
                    src: tile.banners?.[0]?.uri || '',
                    alt: tile.name,
                    width: tile.banners?.[0]?.width,
                    height: tile.banners?.[0]?.height,
                    isSquircle: roundEdgeDevices.includes(deviceName?.toLowerCase()),
                  }}
                  width={90}
                  height={90}
                  borderRadius="16px"
                  borderReservedSpace={false}
                />
              );

              return (
                <ItemRow
                  key={tile.id}
                  id={tile.id}
                  title={tile.name}
                  linkTo={`/v2/tile/${tile.id}`}
                  photo={photo}
                />
              );
            })}
          </ContentList>
          <BottomFixedBar>
            <StyledLinkContainer>
              <ButtonLink to="/v2/tiles/discover" pageDirection="FORWARD" variant="filled" fullWidth>
                {"Add tiles"}
              </ButtonLink>
            </StyledLinkContainer>
            <StyledLinkContainer>
              <ButtonLink to="/v2/my_tiles" pageDirection="FORWARD" variant="outline" fullWidth>
                {"Manage tiles"}
              </ButtonLink>
            </StyledLinkContainer>
          </BottomFixedBar>
        </Container>
      </ScrollContainer>
    );
  }

  render() {
    const { loading, error } = this.props;

    return (
      <HomeContainer selected={RoutePaths.GALLERY_TILES} centerTitle="Tiles">
        {loading || error ? (
          <Transition loading={loading} error={error} headerHeight={64} />
        ) : (
          this.renderBody()
        )}
      </HomeContainer>
    );
  }
}

export default connectDeep(mapStateToProps)(InstalledTilesPage);
